import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  // 기준정보관리 관련 정적 링크들
];

const MobileConfig = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);

  useEffect(() => {
    console.log('=== MobileConfig useEffect 실행됨 ===');
    // API 호출하여 테이블 이름 가져오기 (PC 버전과 동일)
    const fetchBoardTables = async () => {
      try {
        console.log('=== MobileConfig fetchBoardTables 시작 ===');
        const response = await fetch('/request/getBoardTables?category=Config', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('받은 데이터:', data);

        // 가져온 테이블 이름을 링크로 변환
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          dynamicLinks = data.map(table => ({
            path: `/Config/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }

        console.log('생성된 동적 링크들:', dynamicLinks);
        
        // 정적 링크와 동적 링크 결합
        const combinedLinks = [...staticLinks, ...dynamicLinks];
        console.log('최종 combined links:', combinedLinks);
        setLinks([]);
        setTimeout(() => {
          setLinks(combinedLinks);
        }, 100);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        console.log('에러 발생, staticLinks 적용:', staticLinks);
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  
  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="기준정보 관리"
      backPath="/"
    >
      <Outlet context={{ links }} />
    </MobileSubNavigator>
  );
};

export default MobileConfig;